/** @format */

import React, { FC, ReactElement, useEffect, useState } from 'react';
import { Dialog, DialogActions, DialogContent, DialogTitle } from '@material-ui/core';
import CustomTextButtom from '../../../../components/Buttons/CustomTextButton';
import GridContainer from '../../../../components/Grid/GridContainer';
import GridItem from '../../../../components/Grid/GridItem';
import I18n from '../../../../components/Translate/I18n';
import Button from '@material-ui/core/Button';
import { ReactComponent as Cancel } from '../../../../assets/themes/OPL/img/icons/Cancel.svg';
import { SimpleSelect, SimpleSelectElements } from '../../../../components/Adescom/SimpleSelect';
import Typography from '@material-ui/core/Typography';
import CustomInputExtNumber from '../../../../components/CustomInput/CustomInputExtNumber';
import CustomInputExt from '../../../../components/CustomInput/CustomInputExt';

const _ = require('underscore');

type SimCardServiceTypeMappedCustomAddType = {
    open: boolean;
    params: string;
    updateParams: (params: string) => void;
    close: () => void;
    isEdit: boolean;
};

type BmeParams = {
    BMPClientName: string;
    amount: number;
    balMode: string;
};

export const SimCardServiceTypeMappedCustomForm: FC<SimCardServiceTypeMappedCustomAddType> = ({
    open,
    params,
    updateParams,
    close,
    isEdit,
}): ReactElement => {
    const [ballModes] = useState<Array<SimpleSelectElements>>([
        { name: 'ABSOLUTE', value: 'ABSOLUTE' },
        { name: 'DELTA', value: 'DELTA' },
    ]);
    const [objParams, setObjParams] = useState<BmeParams | null>(null);

    const activateCallback = (): void => updateParams(JSON.stringify(objParams));

    useEffect(() => {
        const obj = JSON.parse(params) as BmeParams;
        if (!obj.BMPClientName) {
            obj.BMPClientName = 'MVNE';
        }
        if (!obj.amount) {
            obj.amount = 0;
        }
        if (!obj.balMode) {
            obj.balMode = 'DELTA';
        }
        setObjParams(obj);
    }, [params]);

    const updateSelect = (event: React.ChangeEvent<HTMLSelectElement>): void => {
        const field = event.target.name;
        const selected = event.target.value ?? '-1';
        if (objParams) {
            const p = _.clone(objParams);
            p.balMode = selected;
            setObjParams(p);
        }
    };

    const onChangeEvent = (event: React.ChangeEvent<HTMLInputElement>): void => {
        const value = event.target.value;
        const field = event.target.name;
        const p = _.clone(objParams);
        if (field === 'amount' && objParams) {
            p.amount = parseInt(value ?? 0);
        }
        if (field === 'BMPClientName' && objParams) {
            p.BMPClientName = value;
        }
        setObjParams(p);
    };

    return (
        <Dialog open={open} maxWidth="sm" fullWidth={true}>
            <DialogTitle id="alert-dialog-title">
                <GridContainer justifyContent={'space-between'}>
                    <GridItem xs={11}>
                        <h4>
                            <I18n trans={'prov:feature.mapped_element_add'} />
                        </h4>
                    </GridItem>
                    <GridItem xs={1}>
                        <Button onClick={close} color="primary">
                            <Cancel width={24} height={24} />
                        </Button>
                    </GridItem>
                </GridContainer>
            </DialogTitle>
            <DialogContent>
                <Typography variant="subtitle2">
                    <I18n trans="simcard:f.choose_correct_params" />
                </Typography>
                <GridContainer>
                    <GridItem xs={11}>
                        <SimpleSelect
                            selectedValue={objParams?.balMode}
                            fieldName={'balMode'}
                            label={'balMode'}
                            required={true}
                            elements={ballModes}
                            dispatchName={'no-dispatch'}
                            callback={updateSelect}
                        />
                    </GridItem>
                    <GridItem xs={6}>
                        <CustomInputExtNumber
                            fullWidth={true}
                            labelText={'prov:feature.mapped_amount'}
                            name="amount"
                            value={objParams?.amount}
                            onChange={onChangeEvent}
                        />
                    </GridItem>
                    <GridItem xs={6}>
                        <CustomInputExt
                            fullWidth={true}
                            labelText={'prov:feature.mapped_BMPClientName'}
                            name="BMPClientName"
                            value={objParams?.BMPClientName}
                            onChange={onChangeEvent}
                        />
                    </GridItem>
                </GridContainer>
            </DialogContent>
            <DialogActions>
                <CustomTextButtom callback={close} callbackParam={{}} label={'general:common.cancel'} size="sm" />
                <CustomTextButtom callback={activateCallback} callbackParam={{}} label={'general:common.save'} size="sm" />
            </DialogActions>
        </Dialog>
    );
};
